
import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Control } from "react-hook-form";

interface VariationReasonFieldProps {
  control: Control<any>;
  watchQuoteType: string;
  isLoading: boolean;
}

const VariationReasonField: React.FC<VariationReasonFieldProps> = ({
  control,
  watchQuoteType,
  isLoading
}) => {
  if (watchQuoteType !== 'variation') {
    return null;
  }

  return (
    <FormField
      control={control}
      name="variationReason"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Variation Reason</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Explain why this variation is needed..." 
              {...field} 
              disabled={isLoading}
              rows={3}
            />
          </FormControl>
          <FormDescription>
            Please provide a clear explanation for this variation.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default VariationReasonField;
